import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { type RootState } from "../store"; // Pfad anpassen

export interface Module {
  module: string;
  enabled: string;
}
export interface StationpickerOptions {
  useinputsearch: boolean;
  useapi: boolean;
  regioncodes: string[];
  rangelimit: number;
  resultlimit: number;
}

export interface ORMCoreState {
  modules: Module[];
  parameters: any[];
  language: string;
  stationtype: string;
  apiurl: string | null;
  translations: {};
  googleStatus: boolean;
  stationpickerOptions: StationpickerOptions;
}

const initialState: ORMCoreState = {
  modules: [],
  parameters: [],
  language: "DE",
  stationtype: "RENT",
  apiurl: null,
  translations: {},
  googleStatus: true,
  stationpickerOptions: {
    useinputsearch: true,
    useapi: true,
    regioncodes: ["DE"],
    rangelimit: 50,
    resultlimit: 0,
  },
};

declare global {
  interface Window {
    gm_authFailure?: () => void;
  }
}

export const ormcoreSlice = createSlice({
  name: "ormcore",
  initialState,
  reducers: {
    setModules: (state, action: PayloadAction<Module[]>) => {
      state.modules = action.payload;
    },
    setParameters: (state, action: PayloadAction<any[]>) => {
      state.parameters = action.payload;
    },
    setLanguage: (state, action: PayloadAction<string>) => {
      state.language = action.payload;
    },
    setTranslations: (state, action: PayloadAction<string>) => {
      state.translations = action.payload;
    },
    setGoogleStatus: (state, action: PayloadAction<boolean>) => {
      state.googleStatus = action.payload;
    },
    setStationPickerOptions: (
      state,
      action: PayloadAction<StationpickerOptions>,
    ) => {
      state.stationpickerOptions = action.payload;
    },
    setStationType: (state, action: PayloadAction<string>) => {
      state.stationtype = action.payload;
    },
    setAPIurl: (state, action: PayloadAction<string>) => {
      state.apiurl = action.payload;
    },
  },
});

export const getModule = (state: RootState, moduleName: string) => {
  const name = moduleName.toUpperCase();

  // Deine Environment-Checks
  if (name === "ORM_LOGIN" && process.env.REACT_APP_ORM_LOGIN === "false")
    return "N";
  if (name === "CONCARDIS" && process.env.REACT_APP_CONCARDIS === "false")
    return "N";

  // Suchen im State
  const found = state.general.modules.find(
    (m) => m.module.toUpperCase() === name,
  );

  return found?.enabled || "N";
};

export const getParameter = (state: RootState, parameterName: string) => {
  const parameter = parameterName.toUpperCase();

  if (
    state.general.parameters.find(
      (parameters) => parameters.parameter === parameter,
    )
  ) {
    return state.general.parameters.find(
      (parameters) => parameters.parameter === parameter,
    ).value;
  } else {
    return false;
  }
};

export const getStationType = (state: RootState) => {
  return state.general.stationtype;
};

export const {
  setModules,
  setParameters,
  setLanguage,
  setTranslations,
  setGoogleStatus,
  setStationPickerOptions,
  setStationType,
  setAPIurl,
} = ormcoreSlice.actions;

export default ormcoreSlice.reducer;
